module.exports = __webpack_public_path__ + "img/profil_lapper_Reidar.3d9320bd.png";